import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { ConfigProvider } from 'antd'
import App from './App'
import { AuthProvider } from './hooks/useAuth'
import { landingCopy } from './branding'
import './styles.css'

const copy = landingCopy()
if (typeof document !== 'undefined') {
  const meta = document.querySelector('meta[name="description"]')
  if (meta) meta.setAttribute('content', copy.metaDescription)
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: '#1d4ed8',
          colorText: '#0f172a',
          colorTextSecondary: '#475569',
          colorBgContainer: '#ffffff',
          colorBorder: '#cbd5e1',
          fontFamily: '"DM Sans", "Segoe UI", sans-serif',
          borderRadius: 10,
          controlHeightLG: 44,
        },
        components: {
          Card: {
            colorBgContainer: '#ffffff',
          },
          Form: {
            labelColor: '#0f172a',
          },
        },
      }}
    >
      <BrowserRouter>
        <AuthProvider>
          <App />
        </AuthProvider>
      </BrowserRouter>
    </ConfigProvider>
  </React.StrictMode>
)
